import { TdsNavigation as Navigation } from '@tencent/tds-ui-lite';
import React, { ComponentProps, FC } from 'react';

export const TdsNavigation: FC<ComponentProps<typeof Navigation>> = props => (
  <Navigation {...props} />
);

export { TdsItem } from '@tencent/tds-ui-lite';
